import { useParams } from 'react-router-dom';
import { Group } from '@mantine/core';

import IssueWrapperV2 from '../../issue/components/IssueWrapper';
import ErrorWrapper from '@/components/content/error/ErrorWrapper';
import IssuePlaceholder from '../../issue/components/IssuePlaceholder';
import IssueTitle from '../../issue/components/IssueTitle';
import RequestIntelligence from '../../mailboxes/RequestIntelligence';
import JSONEditTrigger from '../components/JSONEditTrigger';
import SourceLinkButton from '../components/SourceLinkButton';

import { signalSourceUrl, useSignalEntity } from '../services/signals';
import { useSources } from '../../catalogs/features/sources/services/sources';

import { getSignalConfig } from '../configs/signalConfigMap';
import { ticketErrors } from '../../issue/utils/errors';

import type { SignalEntity } from '../types';

const Signal = () => {
  const { entity } = useParams();
  const entityId = entity as string;

  const query = useSignalEntity(entityId);
  const collector = query.data?.collector;

  const config = getSignalConfig(collector).issue;

  const sourceInformation = useSources().ticket(
    query.data?.catalog.source_id,
    {
      queryKey: () => ['ticket', 'signal', query.data?.catalog.source_id],
      enabled: query.isSuccess && typeof query.data?.catalog.source_id !== 'undefined',
    },
    {
      params: {
        path: {
          resource_id: query.data?.catalog.source_id,
        },
      },
    }
  );

  return (
    <ErrorWrapper
      isError={query.isError}
      refetch={query.refetch}
      error={query.error}
      errors={ticketErrors}
      canUpsell
    >
      <IssuePlaceholder isLoading={query.isPending || sourceInformation.isLoading}>
        <IssueTitle
          docTitle="Signal"
          title={
            query.data?.collector === 'botnetlogparser'
              ? (query.data?.attributes.email?.[0] ??
                query.data?.credential?.username ??
                query.data?.title)
              : query.data?.title
          }
        />

        <IssueWrapperV2
          left={config?.[0](collector)}
          right={config?.[1](collector)}
          id={entityId}
          data={{ ...query.data, sourceInformation: sourceInformation.data?.data } as SignalEntity}
          actions={
            <Group gap={10} align="center" justify="center" className="noPrint">
              <SourceLinkButton url={signalSourceUrl(query.data?.link)} iconOnly />
              <JSONEditTrigger
                json={(query.data as SignalEntity)?.raw}
                filename={`signal-${entityId}`}
              />
              <RequestIntelligence ticketId={entityId} iconOnly />
            </Group>
          }
        />
      </IssuePlaceholder>
    </ErrorWrapper>
  );
};

export default Signal;
